// This is a light encapsulation of Axios to incorporate our env configs.
import { Auth0Plugin } from '@/auth'
import { apiUrl202007 } from '@/env'
import { Api } from './api'

export class EveractiveApi {
  private baseUrl = apiUrl202007
  public client: Api

  constructor(baseUrl?: string) {
    if (baseUrl) {
      this.baseUrl = baseUrl
    }
    const apiClientConfig = {
      BASE: apiUrl202007,
      TOKEN: () =>  Auth0Plugin.getTokenSilently(),
      HEADERS: { 'Cache-Control': 'private, no-store, max-age=0' }
    }

    this.client = new Api(apiClientConfig)
  }
}
